<script>
	import { Menu, registerMenuItem } from "@xbs/svelte-menu";
	import { Portal } from "@xbs/svelte-wx";

	import Item from "./Items/Item.svelte";
	import UserItem from "./Items/UserItem.svelte";
	import DatePicker from "./Items/DatePicker.svelte";
	import PriorityItem from "./Items/PriorityItem.svelte";

	registerMenuItem("item", Item);
	registerMenuItem("user", UserItem);
	registerMenuItem("datepicker", DatePicker);
	registerMenuItem("priority", PriorityItem);

	export let options;
	export let parent;
	export let at = "bottom-left";

	export let api;

	$: state = api.getReactiveState();
	$: componentId = state.id;

</script>

<Portal theme="material" let:mount>
	<div class="wx-todo_menu" data-todo-id={$componentId}>
		<Menu {options} {parent} {mount} {at} on:click />
	</div>
</Portal>

<style>
	:global(.wx-todo_menu .menu) {
		background: var(--wx-background);
		box-shadow: var(--wx-box-shadow);
		border-radius: var(--wx-border-radius);
	}
	:global(.wx-todo_menu .menu .separator) {
		border-top: var(--wx-border);
	}
	:global(.wx-todo_menu .menu .item) {
		height: max-content;
		width: max-content;
		min-width: 100%;
		padding: 0;
		margin: 0;
	}
	:global(.wx-todo_menu .menu .item):hover {
		background: inherit;
	}
	:global(.wx-todo_menu .menu .icon),
	:global(.wx-todo_menu .menu .sub-icon) {
		display: none;
	}

</style>
